import { Button, Dialog, Form, Spacer } from '@spritz-finance/ui'
import React from 'react'
import { SubmitHandler } from 'react-hook-form'
import styled, { css } from 'styled-components'
import { Row } from '../../../../components/Layout/Row'
import { useRenameBankAccountMutation } from '../../../../graphql/generated/graphql'
import { BankAccount } from '../BankAccounts'

const RenameAccountContainer = styled.div<{ $removed?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: opacity 0.2s ease-out;
    ${({ $removed }) =>
        $removed &&
        css`
            opacity: 0;
        `};
`

interface RenameFormData {
    name: string
}

interface RenameAccountDialogProps {
    account: BankAccount | null
    onClose: () => void
}

export const RenameAccountDialog: React.VFC<RenameAccountDialogProps> = ({ onClose, account }) => {
    const [renameBill, { loading }] = useRenameBankAccountMutation({
        optimisticResponse: (vars) => {
            return {
                renameCheckbookAccount: {
                    ...account!,
                    name: vars.name,
                },
            }
        },
    })

    const handleCloseDialog = () => {
        if (loading) return
        onClose()
    }

    const onSubmit: SubmitHandler<RenameFormData> = async (data) => {
        renameBill({
            variables: {
                accountId: account!.id ?? '',
                name: data.name,
            },
        })
        onClose()
    }

    return (
        <Dialog open={!!account} onClose={handleCloseDialog}>
            <Dialog.Content>
                <Dialog.Title>Rename Account</Dialog.Title>
                <RenameAccountContainer $removed={false}>
                    <Spacer height={32} />
                    <Spacer height={16} />
                    <Form<RenameFormData>
                        onSubmit={onSubmit}
                        initialValues={{ name: account?.name }}
                    >
                        <Form.Input
                            autoComplete="off"
                            name="name"
                            placeholder="Account nickname"
                            validation={{ required: true }}
                        />
                        <Spacer height={32} />
                        <Row align="center">
                            <Button.CTA type="submit" disabled={loading} style={{ width: '110px' }}>
                                Rename
                            </Button.CTA>
                        </Row>
                    </Form>
                </RenameAccountContainer>
            </Dialog.Content>
        </Dialog>
    )
}
